import React from 'react';
import { motion } from 'framer-motion';

const blobs = [
  {
    color: 'rgba(99, 102, 241, 0.35)',
    size: 620,
    top: '-12%',
    left: '-8%',
    duration: 26,
    delay: 0,
  },
  {
    color: 'rgba(139, 92, 246, 0.30)',
    size: 560,
    top: '-6%',
    left: '55%',
    duration: 30,
    delay: 2,
  },
  {
    color: 'rgba(217, 70, 239, 0.25)',
    size: 520,
    top: '45%',
    left: '10%',
    duration: 34,
    delay: 4,
  },
  {
    color: 'rgba(99, 102, 241, 0.22)',
    size: 480,
    top: '40%',
    left: '60%',
    duration: 28,
    delay: 6,
  },
];

const GradientMesh = ({ variant = 'light', className = '' }) => {
  const baseStyle = {
    background:
      variant === 'dark'
        ? 'linear-gradient(135deg, #0F172A 0%, #1E1B4B 60%, #312E81 100%)'
        : 'transparent',
  };

  return (
    <div
      aria-hidden="true"
      className={`gradient-mesh ${className}`}
      style={{
        position: 'absolute',
        inset: 0,
        overflow: 'hidden',
        pointerEvents: 'none',
        ...baseStyle,
      }}
    >
      {blobs.map((blob, i) => (
        <motion.div
          key={i}
          style={{
            position: 'absolute',
            top: blob.top,
            left: blob.left,
            width: blob.size,
            height: blob.size,
            borderRadius: '50%',
            background: `radial-gradient(circle at center, ${blob.color} 0%, transparent 65%)`,
            filter: 'blur(40px)',
            willChange: 'transform',
          }}
          animate={{
            x: [0, 30, -20, 0],
            y: [0, -20, 25, 0],
            scale: [1, 1.08, 0.96, 1],
          }}
          transition={{
            duration: blob.duration,
            delay: blob.delay,
            repeat: Infinity,
            ease: 'easeInOut',
          }}
        />
      ))}

      {variant === 'light' && (
        <div
          style={{
            position: 'absolute',
            inset: 0,
            background:
              'linear-gradient(to bottom, rgba(255,255,255,0.0) 0%, rgba(255,255,255,0.55) 80%, rgba(255,255,255,1) 100%)',
          }}
        />
      )}
    </div>
  );
};

export default GradientMesh;
